module.exports = __webpack_public_path__ + "static/distill-cinemagraph-ca67dc5fa05a240f75efeb6e99d07e73.mp4";